import * as React from "react";
import styled from "@mui/material/styles/styled";
import {
  PanelContext,
  PatientCaseGrouping,
} from "../../../context/diagnosticAgent";
import { KahunPanelSubGroup } from "shared";
import { DataInputPanel } from "../../dataInputTypes";
import { LevelPanelHeader } from "./levelPanelHeader";
import { MedicationPanelHeader } from "./medicationPanelHeader";

//region [[ Styles ]]

const PanelHeaderView = styled("div")(({ theme }) => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PanelHeaderProps {
  section: PatientCaseGrouping;
  usesLevel: boolean;
  isProcedurePanelAbnormal: (findings: any) => boolean;
  panel: DataInputPanel;
  panelContext: PanelContext;
  getCaseValue: any;
  onMakeNormal?: () => void;
  onSelectAbnormal?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PanelHeader = ({ ...props }: PanelHeaderProps) => {
  return (
    <PanelHeaderView>
      {(props.usesLevel ||
        props.section === PatientCaseGrouping.WORKUP ||
        props.section === PatientCaseGrouping.CLINICAL_FEATURES) &&
        props.panel.id !== KahunPanelSubGroup.Other &&
        props.panel.id !== KahunPanelSubGroup.MostRelevant && (
          <LevelPanelHeader
            findings={props.panel.findings}
            key={"header"}
            onMakeNormal={props.onMakeNormal}
            onSelectAbnormal={props.onSelectAbnormal}
            isProcedurePanelAbnormal={props.isProcedurePanelAbnormal}
            getCaseValue={props.getCaseValue}
            section={props.section}
            itemContext={props.panelContext}
          />
        )}

      {props.section === PatientCaseGrouping.BACKGROUND &&
        props.panelContext.panelCategory.id ===
          KahunPanelSubGroup.Medication && (
          <MedicationPanelHeader
            findings={props.panel.findings}
            key={"header"}
            onMakeNormal={props.onMakeNormal}
            onSelectAbnormal={props.onSelectAbnormal}
            isMedicationPanelAbnormal={props.isProcedurePanelAbnormal}
            getCaseValue={props.getCaseValue}
            section={props.section}
            panelContext={props.panelContext}
          />
        )}
    </PanelHeaderView>
  );
};
